import React from 'react'

import { Card, CardHeader, CardContent, CardActions, Grid } from '@material-ui/core'

import Form from './Form/Form'
import ItemListSelector from './ItemListSelector/ItemListSelector'
import SelectedItemPreview from './SelectedItemPreview/SelectedItemPreview'
import Button from '../../../UI/Button/Button'
import { withTranslate } from 'react-redux-multilingual'

const itemSelectorContent = ({
  // Form Props
  form,
  inputChanged,
  // Selector Props
  currentStructure,
  structureList,
  // selectedStructures,
  selectedItems,
  selectedTags,
  onTagSelected,
  onStructureSelected,
  onItemSelected,
  onItemsAdded,
  // Preview Table Props
  targetItems,
  onItemDeleted,
  // Page Actions Props
  submitted,
  cancelled,
  translate,
  submitDisabled
}) => {
  const itemList = currentStructure?.items || []
  const selectedStructures = structureList
    .filter(struct => {
      const structCode = struct.structure_type.value_list_code
      if (structCode !== 'STT05') {
        return struct.items.some(item => selectedItems.includes(+item.item_id))
      } else if (structCode === 'STT05') {
        return Object.entries(struct.items).some(group => {
          const [, groupAttrs] = group
          return groupAttrs.items.some(item => selectedItems.includes(+item.item_id))
        })
      }
      return false
    })
    .map(struct => struct.structure_id)
  return (
    <Card>
      <CardHeader title={translate('select') + translate('appraisalItem')} />
      <CardContent>
        <Form form={form} inputChanged={inputChanged} />
        <ItemListSelector
          currentStructure={currentStructure}
          items={itemList}
          structures={structureList}
          // selectedStructures={selectedStructures}
          selectedStructures={selectedStructures}
          structureSelected={onStructureSelected}
          selectedItems={selectedItems}
          itemSelected={onItemSelected}
          selectedTags={selectedTags}
          tagSelected={onTagSelected}
          addItemButtonClicked={onItemsAdded}
        />
        <SelectedItemPreview targetItems={targetItems} itemDeleted={onItemDeleted} />
      </CardContent>
      <CardActions>
        <Grid container justify={'flex-end'} spacing={2}>
          <Grid item xs lg={2}>
            <Button color={'primary'} disabled={submitDisabled} clicked={submitted}>
              {translate('save')} ({targetItems.length})
            </Button>
          </Grid>
          <Grid item xs lg={2}>
            <Button color={'default'} clicked={cancelled}>
              {translate('cancel')}
            </Button>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  )
}

export default withTranslate(itemSelectorContent)
